//librerias
import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MsalService } from "@azure/msal-angular";
import { Router } from "@angular/router";

//componentes
import { ModalConfirmacionComponent } from "../../components/modal-confirmacion/modal-confirmacion.component";

//servicios
import { AssistanceService } from "src/app/attendanceRecord/services/asistanceService/assistance.service";
import { ModalSharedServiceService } from "src/app/shared/modals/modal-service.service";
import { SessionsService } from "src/app/services/session/sessions.service";

//interfaces
import { AccountInfo } from "@azure/msal-browser";
import { originDataEnumEmailPerAd } from "../../constants/idOriginAsistance";
import { ICollaborator } from "src/app/models/Interfaces/Collaborators/CollaboratorsResponseInterface";
import { AuthenticationService } from "src/app/auth/services/authentication.service";
import { environment } from "src/environments/environment";
import { ICourseSession } from "../../interfaces/SessionsInterface";
import { IPostAssistanceRegister } from "../../interfaces/AssistanceOpcionalInterface";

@Component({
  selector: "app-home-attendance",
  templateUrl: "./home-attendance.component.html",
  styleUrls: ["./home-attendance.component.css"],
})
export class HomeAttendanceComponent implements OnInit {
  private currentUser: AccountInfo | null = null;
  protected isSessionDataLoading: boolean = false;
  protected isMasterQR: boolean = false;

  public eventData: ICourseSession | null = null;

  // Session Info
  private fkIdSesion?: string;
  public numeroSesion?: string;
  public nombreCurso?: string;
  //  Loading Screen
  public finishedLoadingSpinner: boolean = false;
  public finishedLoadingRegister: boolean = true;

  constructor(
    private assistanceService: AssistanceService,
    private authMSService: MsalService,
    public modalService: NgbModal,
    private router: Router,
    private authService: AuthenticationService,
    private sessionsService: SessionsService,
    private sharedModal: ModalSharedServiceService,
    public modal: NgbModal
  ) {}
  get isSessionStorageSet(): boolean {
    const id = sessionStorage.getItem("fkIdSesion");
    const numero = sessionStorage.getItem("numeroSesion");
    if (id && numero) {
      this.fkIdSesion = id;
      this.numeroSesion = numero;
      return true;
    }
    return false;
  }
  private retrieveAndSetDataFromParams() {
    try {
      let splitUrl = this.router.url.trim();
      if (splitUrl.endsWith("=")) {
        // Eliminar el último carácter de =
        splitUrl = splitUrl.slice(0, -1);
      }
      const encodeParams = splitUrl.split("?")[1];
      if (!encodeParams) {
        // Lost in Redirect and Reload
        return;
      }
      const completarUrl = atob(decodeURIComponent(encodeParams));
      // Dividir los parámetros en pares clave=valor
      const paramsArray = completarUrl.split("&");
      const params: any = {};

      paramsArray.forEach(parametro => {
        const [clave, valor] = parametro.split("=");
        params[clave] = valor;
      });
      this.fkIdSesion = params.fkIdSesion;
      this.numeroSesion = params.numeroSesion;
      sessionStorage.setItem("fkIdSesion", params.fkIdSesion);
      sessionStorage.setItem("numeroSesion", params.numeroSesion);
    } catch (error) {
      console.error(error);
    }
  }

  private sessionStorageFunc() {
    sessionStorage.setItem(
      "fkIdSesion",
      this.fkIdSesion ? this.fkIdSesion : ""
    );
    sessionStorage.setItem(
      "numeroSesion",
      this.numeroSesion ? this.numeroSesion : ""
    );
  }

  async ngOnInit() {
    this.retrieveAndSetDataFromParams();
    if (!this.authService.currentUserValue) {
      // get and set temp auth token when no user is logged
      this.authService.loginToGetToken(environment.botEmail).subscribe({
        error: () => {
          this.sharedModal
            .openModal("error-modal", {
              title: "¡Error!",
              body: "Ha ocurrido un error, por favor recarga la página para intentarlo nuevamente",
            })
            .then();
        },
      });
    }
    //Controlando el AD
    this.currentUser = await this.getMSAlCurrentUser();
    if (!this.isSessionStorageSet) {
      this.sessionStorageFunc();
    } else if (sessionStorage.getItem("registrando") === "true") {
      if (this.currentUser) {
        this.loginAd();
      }
    }
    if (!this.fkIdSesion || !this.authService.currentUserToken) {
      this.finishedLoadingSpinner = true;
      return;
    }
    this.finishedLoadingSpinner = true;
    this.isSessionDataLoading = true;
    this.sessionsService.getSessionBySessionId(this.fkIdSesion).subscribe({
      next: courseSession => {
        this.eventData = courseSession;
        this.nombreCurso = courseSession.titulo;
        this.isSessionDataLoading = false;
        this.isMasterQR = courseSession.QrMeastro;
      },
      error: () => {
        this.isSessionDataLoading = false;
        this.sharedModal
          .openModal("error-modal", {
            title: "¡Error!",
            body: "Ha ocurrido un error al obtener los datos de la sesión, vuelve a intentarlo más tarde",
          })
          .then();
      },
    });
  }
  private async getMSAlCurrentUser(): Promise<AccountInfo | null> {
    let userInfo: AccountInfo | null = null;
    await new Promise<void>(resolve => {
      setTimeout(() => {
        const accounts = this.authMSService.instance.getAllAccounts();
        const uLog = accounts[0];
        console.log(uLog);
        if (uLog) {
          userInfo = uLog;
        }
        resolve();
      }, 1500);
    });
    return userInfo;
  }

  private registerAttendanceUserFoundOnSuccess = (
    attendance: IPostAssistanceRegister
  ) => {
    const fullName = `${attendance.nombre ?? ""} ${
      attendance.segundoNombre ?? ""
    } ${attendance.apellidoPaterno ?? ""} ${attendance.apellidoMaterno ?? ""}`;
    const masterQRData = {
      qrMaestro: this.isMasterQR,
      totalPartesReales: this.eventData?.totalPartesReales,
    };
    sessionStorage.setItem("TYnombre", fullName);
    sessionStorage.setItem("TYMasterQRData", JSON.stringify(masterQRData));
    this.closeModal();
    this.router.navigate(["thankYouPage"]);
  };

  validateDataAndAddAttendant({
    type,
    value,
  }: {
    type: originDataEnumEmailPerAd;
    value: string;
  }) {
    this.assistanceService.addGuestAttendee(
      { type, value },
      {
        mode: "self",
        fkIdSesion: Number(this.fkIdSesion),
        numeroSesion: Number(this.numeroSesion),
        onSuccessFound: d => this.registerAttendanceUserFoundOnSuccess(d),
        onSuccessNotFound: () => {
          this.closeModal();
          this.router.navigate(["thankYouPage"]);
        },
      }
    );
  }

  async loginAd() {
    // Se necesita para el redireccionamiento  en login
    sessionStorage.setItem("registrando", "true");
    sessionStorage.removeItem("logout");
    if (!this.currentUser) {
      this.authMSService.loginRedirect();
      return;
    }
    // Obtener datos de BidaApi
    let userFromHCM: ICollaborator | null = null;
    try {
      userFromHCM = await this.assistanceService.getUserInfoHCM(
        originDataEnumEmailPerAd.activeDirectory,
        this.currentUser.username
      );
    } catch (error: any) {
      const errMsg = error.message
        ? error.message
        : "El usuario no es válido. Por favor, verifica la información e inténtalo de nuevo.";
      this.sharedModal
        .openModal("error-modal", {
          title: "¡Error!",
          body: errMsg,
        })
        .then();
      return;
    }

    if (!userFromHCM) {
      await this.sharedModal.openModal("error-modal", {
        title: "¡Error!",
        body: "Este usuario no se encuentra en HCM,regístrate como invitado",
      });
      return;
    }
    const modalRef = this.modalService.open(ModalConfirmacionComponent, {
      size: "md",
      centered: true,
      backdrop: "static",
    });
    modalRef.componentInstance.nombreUsuario = `${userFromHCM.name} ${userFromHCM.lastName}`;
    modalRef.componentInstance.Close.subscribe(() => {
      modalRef.close();
      sessionStorage.setItem("logout", "true");
      this.authMSService.logoutRedirect();
    });
    modalRef.componentInstance.Confirm.subscribe(() => {
      if (this.fkIdSesion && this.numeroSesion && userFromHCM) {
        {
          this.assistanceService.registerAttendanceUserFound(
            userFromHCM,
            originDataEnumEmailPerAd.activeDirectory,
            {
              mode: "self",
              fkIdSesion: Number(this.fkIdSesion),
              numeroSesion: Number(this.numeroSesion),
              onSuccessFound: d => this.registerAttendanceUserFoundOnSuccess(d),
            }
          );
        }
      }
      modalRef.close();
    });
  }

  openModal(modalToOpen: any) {
    this.modal.open(modalToOpen, {
      size: "lg",
      centered: true,
      scrollable: false,
      backdrop: "static",
    });
  }

  closeModal() {
    this.modal.dismissAll();
  }
}
